import styled from "styled-components";


export const KettleArticle= styled.article`

  border-radius: 15px;
  outline: 1px solid black;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 200px;
  width: 100%;
  //height: 190px;

  //&:hover {
  //  background: rgba(246, 238, 229, 0.5);
  //}

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }

    cursor: none;
  }
`
export const KettleImg= styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  max-width: 100px;
  max-height: 135px;
  margin-bottom: 1px;
`

// export const KettleDegree= styled.div`
//   display: flex;
//   justify-content: center;
//   justify-items: center;
// `
export const KettleTextDegree= styled.p`
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: bold;
`

export const KettleTextStatus= styled.p`
  padding: 0;
  margin: 0 0 2px 0;
`

